module.exports = __webpack_public_path__ + "static/media/PaymentFailueLogo.c615681f.svg";